import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TUpdatePartnerKYCStatusRequest,
  TUpdatePartnerKYCStatusResponse,
} from "./updatePartnerKYCStatus.schema";

export const updatePartnerKYCStatus = (axios: IAxiosInstance) => {
  return async (data: TUpdatePartnerKYCStatusRequest) => {
    const { whiteLabelID, first_name, last_name, kyc_status } = data;

    const response = await axios.noRetry.patch<
      IApiResponse<TUpdatePartnerKYCStatusResponse>
    >(`/api/partners/${whiteLabelID}/kyc-status`, {
      first_name,
      last_name,
      kyc_status,
    });

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
